unit NetNumberItemListType;
{

/* Initial. */

}
interface

uses
  JS,
  NetNumberItemType;

type
  TNetNumberItemArray = array of TNetNumberItemType;

  TNetNumberItemListType = class
    fNetNumberItemArray: TNetNumberItemArray;
  public
    property NetNumberItemArray: TNetNumberItemArray read fNetNumberItemArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TNetNumberItemListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    NetNumberItemType: TNetNumberItemType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      NetNumberItemType := TNetNumberItemType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(NetNumberItemType, fNetNumberItemArray, High(fNetNumberItemArray));
    end;
  end;
end;

end.
